/** Stored identity is distinct from operational compatibility. Keep this mapping
 * as the only definition of the two new types' legacy behaviour. */
export const LOCATION_COMPATIBILITY = {
  warehouse: "warehouse",
  processing_unit: "warehouse",
  branch: "branch",
  rd_center: "branch",
} as const;
export type LocationType = keyof typeof LOCATION_COMPATIBILITY;
export const LOCATION_TYPES = Object.keys(LOCATION_COMPATIBILITY) as LocationType[];
export function isLocationType(value: unknown): value is LocationType {
  return typeof value === "string" && Object.hasOwn(LOCATION_COMPATIBILITY, value);
}
export function legacyLocationType(type: string | null | undefined): string | null | undefined {
  return isLocationType(type) ? LOCATION_COMPATIBILITY[type] : type;
}
export function locationTypesForLegacy(type: "warehouse" | "branch"): LocationType[] {
  return LOCATION_TYPES.filter(key => LOCATION_COMPATIBILITY[key] === type);
}
/** Static SQL expression for trusted identifier names, never user input. */
export function legacyLocationTypeSql(column: string): string {
  if (!/^[a-zA-Z_][a-zA-Z0-9_.]*$/.test(column)) throw new Error("Invalid location type SQL identifier");
  return `(CASE ${LOCATION_TYPES.filter(key=>key!==LOCATION_COMPATIBILITY[key]).map(key=>`WHEN ${column}='${key}' THEN '${LOCATION_COMPATIBILITY[key]}'`).join(" ")} ELSE ${column} END)`;
}
export function locationTypeLabel(type: string, ar = false): string {
  const labels: Record<string, [string,string]> = {
    warehouse: ["Warehouse", "مستودع"], processing_unit: ["Processing unit", "وحدة تصنيع"],
    rd_center: ["R&D center", "مركز البحث والتطوير"], branch: ["Branch", "فرع"],
  };
  return labels[type]?.[ar ? 1 : 0] ?? type;
}
